function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e) {
  var t = {};

  function n(a) {
    if (t[a]) return t[a].exports;
    var o = t[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  n.m = e, n.c = t, n.d = function (e, t, a) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: a
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var a = Object.create(null);
    if (n.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(a, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return a;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 110);
}({
  110: function _(e, t, n) {
    "use strict";

    n.r(t);
    n(111), n(112);
  },
  111: function _(e, t) {
    window.IStorage = window.IStorage || function () {
      var e,
          t,
          n = "istorage js-istorage",
          a = "getRequest",
          o = "getResponse",
          r = "setRequest",
          u = "setResponse",
          c = "triggerRequest",
          i = "triggerResponse",
          s = 0,
          l = {},
          d = {},
          f = [];

      function p(t) {
        var a, o;
        e && e.dataset.isLoaded ? v(t) : (a = function a() {
          v(t);
        }, t.payload.key, f.push(a), e || ((o = document.createElement("iframe")).src = app.config.istorageIframeURL, o.className = n, e = o, document.body.append(e), e.onload = function () {
          e.dataset.isLoaded = !0, f.forEach(function (e) {
            e();
          });
        }));
      }

      function y(e, t) {
        e.postMessage(JSON.stringify(t), "*");
      }

      function v(t) {
        y(e.contentWindow, t);
      }

      function g(e) {
        return e.includes("ssoUserToken");
      }

      function m(e) {
        var t = ("; " + document.cookie).split("; " + e + "=");
        if (2 == t.length) return t.pop().split(";").shift();
      }

      function k(e, n) {
        var s = n.payload;

        switch (n.type) {
          case a:
            y(e, {
              type: o,
              payload: {
                value: t.getItem(s.key) || g(s.key) && m(s.key),
                requestID: s.requestID
              }
            });
            break;

          case r:
            t.setItem(s.key, s.value), g(s.key) && (document.cookie = "".concat(s.key, "=").concat(s.value, "; Secure; Max-Age=31536000; Path=/; SameSite=None;")), y(e, {
              type: u,
              payload: {
                key: s.key,
                value: s.value,
                requestID: s.requestID
              }
            });
            break;

          case u:
            S(s.requestID, {
              key: s.key,
              value: s.value,
              source: e
            });
            break;

          case o:
            S(s.requestID, s.value, e);
            break;

          case c:
            t.setItem(s.eventName, JSON.stringify({
              data: s.data,
              requestID: s.requestID
            })), t.removeItem(s.eventName);
            break;

          case i:
            !function (e, t) {
              d[e] && d[e].forEach(function (e) {
                e(t);
              });
            }(s.eventName, s.data), S(s.requestID);
        }
      }

      function b(e) {
        var t;

        try {
          t = JSON.parse(e);
        } catch (e) {
          return;
        }

        return t;
      }

      function I(e) {
        var t = b(e.data);
        t && k(e.source, t);
      }

      function w(e) {
        if (e.newValue) {
          var t = b(e.newValue);
          y(window.parent, {
            type: i,
            payload: {
              eventName: e.key,
              data: t && t.data,
              requestID: t && t.requestID
            }
          });
        }
      }

      function q(e) {
        var t;
        t = e.callback, l[++s] = t, p({
          type: e.type,
          payload: Object.assign({}, e.payload, {
            requestID: s
          })
        });
      }

      function S(e, t, n) {
        l[e] && l[e](t, n), delete l[e];
      }

      function h() {
        window.addEventListener("storage", w);
      }

      return function () {
        window.location !== window.parent.location && window.addEventListener("load", h);

        try {
          localStorage.getItem("");
        } catch (e) {
          return console.warn('Cross domain storage blocked, because "Block third-party cookies" is enable'), void (t = {
            setItem: function setItem() {},
            getItem: function getItem() {},
            removeItem: function removeItem() {}
          });
        }

        t = localStorage;
      }(), window.addEventListener("message", I), {
        get: function get(e, t) {
          q({
            type: a,
            callback: t,
            payload: {
              key: e
            }
          });
        },
        set: function set(e, t, n) {
          q({
            type: r,
            callback: n,
            payload: {
              key: e,
              value: t
            }
          });
        },
        trigger: function trigger(e, t, n) {
          q({
            type: c,
            callback: n,
            payload: {
              eventName: e,
              data: t
            }
          });
        },
        on: function on(e, t) {
          d[e] ? d[e].push(t) : d[e] = [t];
        },
        removeEventListeners: function removeEventListeners(e) {
          delete d[e];
        }
      };
    }();
  },
  112: function _(e, t, n) {}
});